// Feature subjects and actions for the per-user permission model. A FEATURE is
// a gated area of the app (e.g. the Dispatch Board); an action is what you can
// do with it (view / edit). Components gate UI with
// useAbility().can(<action>, <feature>).
//
// Action names are intentionally the literal `view` / `edit` from the
// permissions spreadsheet — they are plain CASL action strings.

export const FEATURES = {
  SHIFT_REPORT: 'ShiftReport', // /fleet/drivers/report
  DRIVER_SHIFT: 'DriverShift', // /fleet/drivers/schedule (the shift scheduler)
  DISPATCH_BOARD: 'DispatchBoard', // /fleet/dispatch
};

export const FEATURE_ACTIONS = {
  VIEW: 'view',
  EDIT: 'edit',
};
